import { TriangleAlert } from 'lucide-react';
import React from 'react';
import Button from '../../../ComponentsV1/Button';

const LocationUpdateConformationUI = ({
  cancelLocationUpdate,
  handleUpdateLocation,
  isUpdatingCustomerLocation,
}) => {
  return (
    <div className='tw-flex tw-flex-col tw-gap-2 tw-items-end tw-mt-5 tw-w-full'>
      <div className='tw-text-400 tw-font-medium tw-flex tw-items-center tw-gap-2 tw-w-full'>
        <TriangleAlert size={18} color='red' />
        Confirm Location Update
      </div>
      <div className='tw-font-medium tw-text-grey-700 tw-w-full tw-flex tw-flex-col tw-gap-2 tw-mt-2'>
        <div>
          This action will update the delivery location for both the customer
          and the rider.
        </div>
        <div>
          Please ensure the new address is correct — we recommend confirming
          with the customer before proceeding.
        </div>
        <div>
          <strong>Note:</strong> The Location can be updated only once per
          order.
        </div>
      </div>
      <div className='tw-flex tw-gap-2 tw-mt-2'>
        <Button
          title={"Don't Update Drop Location"}
          type='secondary'
          size='medium'
          className='tw-bg-grey-100'
          onClick={cancelLocationUpdate}
        />
        <Button
          title={'Update Drop Location'}
          size='medium'
          onClick={handleUpdateLocation}
          loading={isUpdatingCustomerLocation}
        />
      </div>
    </div>
  );
};

export default LocationUpdateConformationUI;
